import * as React from "react";
import { forwardRef } from "react";
const SvgIconPlay = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m0 0 12.016 8L0 16z", "data-name": "icon/play", transform: "translate(3.857)", fill: "#fff" }));
const ForwardRef = forwardRef(SvgIconPlay);
export { ForwardRef as ReactComponent };
